import { styled } from '@linaria/react';

const BaseChild = styled.div`
  --padding: 16px; /* NOTE: Used by children */
  --card-bg: var(--color-cloud-300);
  padding: var(--padding);
  background: var(--card-bg);
  border-radius: var(--padding);
  transition: background var(--color-swap-duration);

  html[data-color-mode='dark'] & {
    --card-bg: hsl(213deg 30% 15%);
  }

  p {
    text-align: center;
    text-wrap: balance;

    &:not(:last-child) {
      margin-bottom: 1em;
    }
  }

  /* Breaking my rule and styling children */
  em {
    font-family: var(--font-family-mono);
    letter-spacing: -0.03125rem;
    -webkit-font-smoothing: subpixel-antialiased;
    color: hsl(220deg 70% 34%);

    html[data-color-mode='dark'] & {
      color: hsl(345deg 100% 60%);
      color: oklch(0.71 0.24 12.88);
    }
  }

  p.small {
    --color-primary: currentColor;
    font-size: 0.875rem;
    text-align: center;
    color: var(--color-gray-700);
  }

  .inset {
    --inset-by: calc(var(--padding) - 8px);
    display: block;
    margin: calc(var(--inset-by) * -1);
    margin-bottom: var(--padding);
    width: calc(100% + var(--inset-by) * 2);
    max-width: calc(100% + var(--inset-by) * 2);
    border-radius: var(--inset-by);
  }
`;

export default BaseChild;
